// src/components/StreakCelebration.js

import React, { useEffect, useState } from 'react';
import Confetti from 'react-confetti';

function StreakCelebration({ streak }) {
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    if (streak > 0 && streak % 7 === 0) {
      setShowConfetti(true);
      const timer = setTimeout(() => setShowConfetti(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [streak]);

  return showConfetti ? (
    <Confetti
      recycle={false}
      numberOfPieces={200}
      onConfettiComplete={() => setShowConfetti(false)}
    />
  ) : null;
}

export default StreakCelebration;
